import { render, staticRenderFns } from "./PerformanceReportVersionForm.vue?vue&type=template&id=1929f324&scoped=true"
import script from "./PerformanceReportVersionForm.vue?vue&type=script&lang=js"
export * from "./PerformanceReportVersionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1929f324",
  null
  
)

export default component.exports